import { combineReducers } from 'redux';
import userReducer from './user.reducer';
import ecommerceReducer from './ecommerce.reducer';

export default combineReducers({
   userReducer,
   ecommerceReducer
});
